export function initStartpageFeatureHero(): void {
  const heroElements = document.querySelectorAll<HTMLElement>('[data-component="startpage-feature-hero"]');

  function updateHeaderHeight() {
    const mediaQuery = window.matchMedia('(max-width: 767px)');

    if (mediaQuery.matches) {
      heroElements.forEach(heroElement => {
        const mediaHeader = heroElement.querySelector<HTMLElement>('.startpage-feature__media-header');

        if (mediaHeader) {
          const headerHeight = mediaHeader.offsetHeight;
          heroElement.style.setProperty('--spf-media-header-height', `${headerHeight / 16}rem`);
        }
      });
    }
  }

  function setLinearGradientStop() {
    heroElements.forEach(heroElement => {
      const captionContainer = heroElement.querySelector<HTMLElement>('.startpage-feature__caption-container');

      if (captionContainer) {
        const captionContainerHeight = captionContainer.offsetHeight;
        heroElement.style.setProperty('--spf-caption-container-height', `${captionContainerHeight / 16}rem`);
      }
    });
  }

  // Initial check
  updateHeaderHeight();
  setLinearGradientStop();

  // Listen for changes
  window.addEventListener('resize', () => {
    updateHeaderHeight();
    setLinearGradientStop();
  });
}

// Auto-initialize on DOMContentLoaded
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initStartpageFeatureHero);
} else {
  initStartpageFeatureHero();
}
